export const DIBS_ENABLE_ONLINE_PREVIEW = 'dibs.enable_online_preview';
export const RX_FORMS_ENABLE_RETAINER_CASES = 'rx_forms.enable_retainer_cases';

export const EDITABLE_GLOBAL_SETTINGS = [
  {
    key: DIBS_ENABLE_ONLINE_PREVIEW,
    title: 'Online DIBS Preview',
    description:
      'Show the Online DIBS Preview button on the patients list when a preview is available.',
    type: 'boolean'
  },
  {
    key: RX_FORMS_ENABLE_RETAINER_CASES,
    title: 'Retainer Cases',
    description:
      'Allow doctors to start retainer cases. When disabled, Start a New Case opens the IDB tray form directly.',
    type: 'boolean'
  }
];
